import { Component, Input } from '@angular/core';
import {ObjectsService} from "@app/_services";

@Component({
  selector: 'cards-item-list',
  templateUrl: './cards-item-list.component.html',
  styleUrls: ['./cards-item-list.component.scss']
})
export class CardsItemListComponent {
  @Input() card:any;
  show:boolean;

  constructor(private objectsService: ObjectsService) {
  }

  get header() {
    return this.objectsService.getValue(this.card, 'header-required')
  }

    get html() {
    return this.objectsService.getValue(this.card, 'html-required')
  }

  toggle(){
    this.show = !this.show;
  }

}
